import Blockly from 'blockly'
import 'blockly/python'

let blockJson = {
  type: 'machine_ifzero_lcd_print',
  message0: '%{BKY_CUSTOM_MACHINE_IFZERO_LCD_PRINT}',
  args0: [
    {
      type: 'field_image',
      src: 'https://i.ibb.co/kByzBzq/ifkit.jpg',
      width: 30,
      height: 30,
      alt: '*'
    },
    {
      type: 'input_value',
      name: 'MESSAGE',
      check: 'String'
    }
  ],
  inputsInline: true,
  previousStatement: null,
  nextStatement: null,
  style: 'display_blocks',
  tooltip: '%{BKY_CUSTOM_MACHINE_IFZERO_LCD_PRINT_TOOLTIP}',
  helpUrl: '',
  mutator: 'machine_ifzero_lcd_print_ext'
}

Blockly.Blocks['machine_ifzero_lcd_print'] = {
  init: function () {
    this.jsonInit(blockJson)
    this.inputs_ = Array(OPTIONS.length).fill('FALSE')
  }
}

Blockly.Python['machine_ifzero_lcd_print'] = function (block) {
  if (!block.disabled)
    Blockly.Python.definitions_.import_ifzero = 'import ifzero'
  let message = Blockly.Python.valueToCode(
    block,
    'MESSAGE',
    Blockly.Python.ORDER_ATOMIC
  )
  let align = block.getFieldValue('ALIGN')
  let line = block.getFieldValue('LINE')
  let code
  if (align === null) code = `ifzero.lcdPrint(${message})\n`
  else code = `ifzero.lcdPrint(${message}, ${align}, ${line})\n`
  return code
}

const OPTIONS = ['extention']
const FIELDS = ['MESSAGE', 'ALIGN', 'LINE', '']

Blockly.Blocks['machine_ifzero_lcd_print_ext'] = {
  init: function () {
    const TITLES = [Blockly.Msg.CUSTOM_MACHINE_IFZERO_LCD_PRINT_V_EXTENTION]
    for (let i = 0; i < OPTIONS.length; i++) {
      this.appendDummyInput()
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField(TITLES[i])
        .appendField(new Blockly.FieldCheckbox(false), OPTIONS[i])
    }
    this.setStyle('ifzero_blocks')
    this.setTooltip('')
    this.setHelpUrl('')
  }
}

Blockly.Constants.ifzeroLcdPrint = {}
Blockly.Constants.ifzeroLcdPrint.BORDER_MUTATOR_MIXIN = {
  connections_: Array(OPTIONS.length).fill(null),
  mutationToDom: function () {
    let container = document.createElement('mutation')
    for (let i = 0; i < this.inputs_.length; i++) {
      if (this.inputs_[i] == 'TRUE') {
        container.setAttribute(OPTIONS[i], this.inputs_[i])
      }
    }
    return container
  },
  domToMutation: function (xmlElement) {
    for (let i = 0; i < this.inputs_.length; i++) {
      this.inputs_[i] = xmlElement.getAttribute(OPTIONS[i].toLowerCase())
    }
    this.updateShape_()
  },
  decompose: function (workspace) {
    let containerBlock = workspace.newBlock('machine_ifzero_lcd_print_ext')
    for (let i = 0; i < this.inputs_.length; i++) {
      containerBlock.setFieldValue(this.inputs_[i], OPTIONS[i])
    }
    containerBlock.initSvg()
    return containerBlock
  },
  compose: function (containerBlock) {
    // Get check box values
    let isChenaged = false
    for (let i = 0; i < this.inputs_.length; i++) {
      if (this.inputs_[i] !== containerBlock.getFieldValue(OPTIONS[i])) {
        this.inputs_[i] = containerBlock.getFieldValue(OPTIONS[i])
        isChenaged = true
      }
    }
    if (isChenaged) this.updateShape_()
    // Reconnect any child blocks
    for (let i = 0; i < OPTIONS.length; i++) {
      if (this.getInput(OPTIONS[i])) {
        Blockly.Mutator.reconnect(this.connections_[i], this, OPTIONS[i])
      }
    }
  },
  saveConnections: function () {
    for (let i = 0; i < this.inputs_.length; i++) {
      let input = this.getInput(OPTIONS[i])
      if (input) {
        this.connections_[i] = input && input.connection.targetConnection
      }
    }
  },
  updateShape_: function () {
    // Delete everything.
    const messageBlock = this.getInputTargetBlock('MESSAGE')
    FIELDS.forEach((element) => {
      if (this.getInput(element)) {
        this.removeInput(element)
      }
    })
    if (this.inputs_[0] == 'TRUE') {
      this.jsonInit({
        message0: '%{BKY_CUSTOM_MACHINE_IFZERO_LCD_PRINT_EXT}',
        args0: [
          {
            type: 'field_image',
            src: 'https://i.ibb.co/kByzBzq/ifkit.jpg',
            width: 30,
            height: 30,
            alt: '*'
          },
          {
            type: 'input_value',
            name: 'MESSAGE',
            check: 'String'
          },
          {
            type: 'field_dropdown',
            name: 'ALIGN',
            options: [
              ['%{BKY_CUSTOM_MACHINE_IFZERO_LCD_PRINT_V_LEFT}', '1'],
              ['%{BKY_CUSTOM_MACHINE_IFZERO_LCD_PRINT_V_CENTER}', '2'],
              ['%{BKY_CUSTOM_MACHINE_IFZERO_LCD_PRINT_V_RIGHT}', '3']
            ]
          },
          {
            type: 'field_dropdown',
            name: 'LINE',
            options: [
              ['0', '0'],
              ['1', '1'],
              ['2', '2'],
              ['3', '3']
            ]
          }
        ],
        tooltip: '%{BKY_CUSTOM_MACHINE_IFZERO_LCD_PRINT_EXT_TOOLTIP}'
      })
    } else {
      this.jsonInit({
        message0: '%{BKY_CUSTOM_MACHINE_IFZERO_LCD_PRINT}',
        args0: [
          {
            type: 'field_image',
            src: 'https://i.ibb.co/kByzBzq/ifkit.jpg',
            width: 30,
            height: 30,
            alt: '*'
          },
          {
            type: 'input_value',
            name: 'MESSAGE',
            check: 'String'
          }
        ],
        tooltip: '%{BKY_CUSTOM_MACHINE_IFZERO_LCD_PRINT_TOOLTIP}'
      })
    }
    if (messageBlock) {
      const parentConnection = this.getInput('MESSAGE').connection
      const childConnection = messageBlock.outputConnection
      parentConnection.connect(childConnection)
    }
  }
}

Blockly.Extensions.registerMutator(
  'machine_ifzero_lcd_print_ext',
  Blockly.Constants.ifzeroLcdPrint.BORDER_MUTATOR_MIXIN,
  null,
  ['']
)
